// extracted by mini-css-extract-plugin
module.exports = {"container":"Bullet_container__JT3LI","circle":"Bullet_circle__n75ov"};